import comPartner from './partner.vue'

export default comPartner
